module.exports = __webpack_public_path__ + "02_bob_black.fc281177.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/02_bob_black.png
// module id = zI9h
// module chunks = 0